import { GetPresignedUrlResponseDTO, GetUserResponseDTO } from '@twygs/shared/publisher-interface';
import axiosInstance from './axios-instance';

export const resignUrl = async (data) => {
  const result: GetPresignedUrlResponseDTO = await axiosInstance.post(
    `/api/v1/publisher/user/gen-presigned-url`,
    data
  );

  return {
    data: result.data
  };
};

export const updateProfile = async (data) => {
  const result: GetUserResponseDTO = await axiosInstance.post(
    `/api/v1/publisher/user/update`,
    data
  );
  return result.data;
};

export const updatePassword = async (data) => {
  const result = await axiosInstance.post(`/api/v1/publisher/user/update-password`, data);

  return result.data;
};
